<script setup>
import { Link } from '@inertiajs/vue3'

defineProps({
  title: { type: String, default: null },
  icon: { type: [Object, Function], default: null },
  linkLabel: { type: String, default: null },
  linkHref: { type: String, default: '#' },
})
</script>

<template>
  <section class="flex flex-col rounded-card bg-white shadow-card">
    <header v-if="title" class="flex items-center gap-3 px-5 pt-5 pb-4">
      <component :is="icon" v-if="icon" class="h-5 w-5 shrink-0 text-up-navy" aria-hidden="true" />
      <h2 class="text-base font-bold tracking-wide uppercase text-up-navy">{{ title }}</h2>
      <Link
        v-if="linkLabel"
        :href="linkHref"
        class="ml-auto shrink-0 text-sm text-slate-500 transition-colors hover:text-up-orange"
      >
        {{ linkLabel }} <span aria-hidden="true">→</span>
      </Link>
    </header>
    <div class="flex flex-1 flex-col px-5 pb-5">
      <slot />
    </div>
  </section>
</template>
